module.exports = __webpack_public_path__ + "img/thumbnail_RedDeer_m_leucistic.59e02a5a.png";